import React, { useState, useEffect, useMemo } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
// import ReactTooltip from 'react-tooltip';
import SkyModal from './modal.js';

function EditableCell({ value: initialValue, id, readOnly, onCommit }) {
  const [value, setValue] = useState(initialValue);
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    setValue(initialValue);
    setIsDirty(false);
  }, [initialValue]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    setIsDirty(newValue !== initialValue);
  };

  const handleBlur = (e) => {
    if (isDirty) {
      setIsDirty(false);
      if (onCommit) onCommit(e);
    }
  };

  return (
    <input
      readOnly={readOnly}
      className={'input-sm container-fluid' + (isDirty ? ' input-dirty' : '')}
      id={id}
      onChange={handleChange}
      onBlur={handleBlur}
      value={value}
    />
  );
}

// Read-only grid value. Borrows the same .input-sm/.container-fluid box as the
// editable cells so its text lines up with the inputs either side of it.
function ReadOnlyCell({ value }) {
  return (
    <div className="input-sm container-fluid readonly-cell" title={value}>
      {value}
    </div>
  );
}

//This table component has all the properties, styling, filtering involved
function Table(props) {

  const [selected, setSelected] = useState(-1);

  var data, modifiedRows, loading, user, modalRow, handleShow, handleClose, show, editable, updateAccess, accountSelected, newStore_allStore;
  var allowedToEdit = props.allowedToEdit;
  data = props.data;
  modifiedRows = props.modified;
  user = props.user;
  handleShow = props.handleShow;
  handleClose = props.handleClose;
  show = props.modalState.show;
  modalRow = props.modalState.modalRow;
  updateAccess = props.updateAccess;
  accountSelected = props.account;
  newStore_allStore = props.newStore_allStore;

  if (data.length > 0) {
    loading = false;
  } else {
    loading = true;
  }


  const columns = useMemo(() => [
    {
      columns: [
        {
          Header: "Account",
          accessor: "Account",
          filterMethod: (filter, row) =>
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
          Cell: (row) => <ReadOnlyCell value={row.original['Account']} />,
        },
        {
          Header: "Store Number",
          accessor: "STORE_NUMBER",
          filterMethod: (filter, row) =>
            (row[filter.id].toLowerCase() === filter.value.toLowerCase()),
          sortMethod: (a, b) => {
            const numA = parseFloat(a);
            const numB = parseFloat(b);
            if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
            return a > b ? 1 : -1;
          },
          Cell: (row) => <ReadOnlyCell value={row.original['STORE_NUMBER']} />,
        },
        {
          Header: "Store Name",
          accessor: "STORE_NAME",
          filterMethod: (filter, row) =>
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
          Cell: (row) => (
            <EditableCell
              readOnly={!updateAccess && !allowedToEdit}
              id={'STORE_NAME|' + row.original['TRADE_PARTNER_ID'] + '|' + row.original['STORE_NUMBER'] + '|' + row.viewIndex}
              onCommit={props.editable}
              value={row.original['STORE_NAME']} />
          ),
        },
        {
          Header: "City",
          accessor: "CITY",
          filterMethod: (filter, row) =>
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
          Cell: (row) => (
            <EditableCell
              readOnly={!(updateAccess && (row.original.latitude === 'None' && row.original.longitude === 'None')) && !allowedToEdit}
              id={'CITY|' + row.original['TRADE_PARTNER_ID'] + '|' + row.original['STORE_NUMBER'] + '|' + row.viewIndex}
              onCommit={props.editable}
              value={row.original['CITY']} />
          ),
        },
        {
          Header: "State",
          accessor: "STATE",
          filterMethod: (filter, row) =>
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
          Cell: (row) => (
            <EditableCell
              readOnly={!(updateAccess && (row.original.latitude === 'None' && row.original.longitude === 'None')) && !allowedToEdit}
              id={'STATE|' + row.original['TRADE_PARTNER_ID'] + '|' + row.original['STORE_NUMBER'] + '|' + row.viewIndex}
              onCommit={props.editable}
              value={row.original['STATE']} />
          ),
        },
        {
          Header: "Country",
          accessor: "UDEF9",
          filterMethod: (filter, row) =>
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
          Cell: (row) => (
            <EditableCell
              readOnly={!(updateAccess && (row.original.latitude === 'None' && row.original.longitude === 'None')) && !allowedToEdit}
              id={'UDEF9|' + row.original['TRADE_PARTNER_ID'] + '|' + row.original['STORE_NUMBER'] + '|' + row.viewIndex}
              onCommit={props.editable}
              value={row.original['UDEF9']} />
          ),
        },
        {
          Header: "Address",
          accessor: "ADDRESS",
          filterMethod: (filter, row) =>
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
          Cell: (row) => (
            <EditableCell
              readOnly={!(updateAccess && (row.original.latitude === 'None' && row.original.longitude === 'None')) && !allowedToEdit}
              id={'ADDRESS|' + row.original['TRADE_PARTNER_ID'] + '|' + row.original['STORE_NUMBER'] + '|' + row.viewIndex}
              onCommit={props.editable}
              value={row.original['ADDRESS']} />
          ),
        },
        {
          Header: "Mall Name",
          accessor: "MALL_NAME",
          filterMethod: (filter, row) =>
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
          Cell: (row) => (
            <EditableCell
              readOnly={!allowedToEdit}
              id={'MALL_NAME|' + row.original['TRADE_PARTNER_ID'] + '|' + row.original['STORE_NUMBER'] + '|' + row.viewIndex}
              onCommit={props.editable}
              value={row.original['MALL_NAME']} />
          ),
        },
        {
          Header: "Region",
          accessor: "REGION",
          filterMethod: (filter, row) =>
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
          Cell: (row) => <ReadOnlyCell value={row.original['REGION']} />,
        },
        {
          Header: "Zip",
          accessor: "ZIP",
          filterMethod: (filter, row) =>
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
          Cell: (row) => (
            <EditableCell
              readOnly={!(updateAccess && (row.original.latitude === 'None' && row.original.longitude === 'None')) && !allowedToEdit}
              id={'ZIP|' + row.original['TRADE_PARTNER_ID'] + '|' + row.original['STORE_NUMBER'] + '|' + row.viewIndex}
              onCommit={props.editable}
              value={row.original['ZIP']} />
          ),
        },
        {
          Header: "Latitude",
          accessor: "latitude",
          filterMethod: (filter, row) =>
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
          sortMethod: (a, b) => {
            const numA = parseFloat(a);
            const numB = parseFloat(b);
            if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
            return a > b ? 1 : -1;
          },
          Cell: (row) => (
            <EditableCell
              readOnly={!updateAccess && !allowedToEdit}
              id={'latitude|' + row.original['TRADE_PARTNER_ID'] + '|' + row.original['STORE_NUMBER'] + '|' + row.viewIndex}
              onCommit={props.editable}
              value={row.original['latitude']} />
          ),
        },
        {
          Header: "Longitude",
          accessor: "longitude",
          filterMethod: (filter, row) =>
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
          sortMethod: (a, b) => {
            const numA = parseFloat(a);
            const numB = parseFloat(b);
            if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
            return a > b ? 1 : -1;
          },
          Cell: (row) => (
            <EditableCell
              readOnly={!updateAccess && !allowedToEdit}
              id={'longitude|' + row.original['TRADE_PARTNER_ID'] + '|' + row.original['STORE_NUMBER'] + '|' + row.viewIndex}
              onCommit={props.editable}
              value={row.original['longitude']} />
          ),
        },
        {
          Header: "Store Type",
          accessor: "STORE_TYPE",
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value.toLowerCase()),
          Cell: (row) => (
            <select
              className="input-sm"
              id={'STORE_TYPE|' + row.original['TRADE_PARTNER_ID'] + '|' + row.original['STORE_NUMBER'] + '|' + row.viewIndex}
              onChange={updateAccess || allowedToEdit ? props.editable : null}
              style={{ width: "100%" }}
              value={row.original.STORE_TYPE.trim()}
            >
              <option value={row.original.STORE_TYPE.trim()} disabled>{row.original.STORE_TYPE.trim()}</option>
              <option value="Undefined">Undefined</option>
              <option value="Full Line">Full Line</option>
              <option value="Outlet">Outlet</option>
              <option value="Direct">Direct</option>
              <option value="Military">Military</option>
            </select>
          ),
          filterMethod: (filter, row) => {
            if (filter.value === '') return '';
            if (filter.value === 'Undefined') return row[filter.id] === 'Undefined';
            if (filter.value === 'Full Line') return row[filter.id] === 'Full Line';
            if (filter.value === 'Outlet') return row[filter.id] === 'Outlet';
            if (filter.value === 'Direct') return row[filter.id] === 'Direct';
            if (filter.value === 'Military') return row[filter.id] === 'Military';
          },
          Filter: ({ filter, onChange }) =>
            <select
              onChange={event => onChange(event.target.value)}
              style={{ width: "100%" }}
              value={filter ? filter.value : ''}
            >
              <option value="Undefined">Undefined Only</option>
              <option value="">Show All</option>
              <option value="Full Line">Full Line</option>
              <option value="Outlet">Outlet</option>
              <option value="Direct">Direct</option>
              <option value="Military">Military</option>
            </select>
        },
        {
          Header: "DC Flag",
          accessor: "DC_FLAG",
          maxWidth: 150,
          filterMethod: (filter, row) =>
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
          Cell: (row) => (
            <select
              className="input-sm"
              id={'DC_FLAG|' + row.original['TRADE_PARTNER_ID'] + '|' + row.original['STORE_NUMBER'] + '|' + row.viewIndex}
              onChange={updateAccess || allowedToEdit ? props.editable : null}
              style={{ width: "100%" }}
              value={String(row.original.DC_FLAG === "None" ? "Undefined" : row.original.DC_FLAG)}
            >
              <option value="Undefined" disabled>--</option>
              <option value="0">NON-DC</option>
              <option value="1">DC</option>
            </select>
          )
        },
        {
          Header: " ",
          accessor: " ",
          maxWidth: 75,
          filterMethod: (filter, row) =>
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
          Cell: (row) => (
            <a href="#"
              data-toggle="tooltip"
              onClick={() => { handleShow(row.original) }}
              title={'Lat: ' + row.original.latitude + ',\nLong: ' + row.original.longitude + ', \nRegion: ' + row.original.REGION + ',\nCurrency: ' + row.original.UDEF6}
            ><span className='glyphicon glyphicon-info-sign'></span></a>
          )
        }
      ]
    }
  ], [updateAccess, allowedToEdit, props.editable, handleShow]);

  return (

    <div>
      <SkyModal selected={selected} handleShow={handleShow} handleClose={handleClose} show={show} row={modalRow} />
      {
          loading && newStore_allStore === 'New Stores' && accountSelected === null ?
          <div style={{ textAlign: "center", padding: "35px" }}>
            <h2>Select an Account to display data on table!</h2></div>
          : loading && data.length === 0 ?
            <h3>No Data!</h3>
            :

            <ReactTable
              data={data}
              loading={loading}
              defaultPageSize={25}
              filterable={true}
              defaultFilterMethod={(filter, row) =>
                String(row[filter.id]) === filter.value}

              getTrProps={(state, rowInfo) => {
                var ri_, containsRow;
                var noCheckList = ['STATE', 'CITY', 'UDEF9', 'STORE_TYPE', '_tableRow'];
                ri_ = rowInfo !== undefined ? rowInfo.original : undefined;

                if (ri_) {
                  containsRow = modifiedRows.some((elem, index) => {
                    var res = true;

                    for (var key in elem) {
                      if (noCheckList.indexOf(key) >= 0) continue;
                      if (JSON.stringify(elem[key]) !== JSON.stringify(ri_[key])) {
                        res = false;
                        break;
                      }
                    }
                    return res;
                  });
                }



                return {
                  onClick: (e) => {
                    setSelected(rowInfo.index)
                  },

                  style: {
                    background: containsRow ? '#c2ffaf' : 'white'
                  }
                }
              }
              }

              columns={columns}

              className="-striped -highlight"
            />

      }
      <br />
    </div>
  );

}

export default Table;
